export const environment = {
  production: false,
  API_BASE_URL: 'https://dev-rectilineus-backend.vercel.app/admin', // Development backend
};
